import { useOnboardingGuidedTourStore } from "./onboarding-guided-tour.store";

export const useGuidedTourLogic = () => {
  const status = useOnboardingGuidedTourStore((state) => state.status);
  const scheduleTour = useOnboardingGuidedTourStore(
    (state) => state.scheduleTour,
  );
  const startTour = useOnboardingGuidedTourStore((state) => state.startTour);
  const completeTour = useOnboardingGuidedTourStore(
    (state) => state.completeTour,
  );

  return {
    isOnboardingTourPending: status === "pending",
    isOnboardingTourRunning: status === "running",
    scheduleTour,
    startTour,
    completeTour,
  };
};
